import React from 'react';
import { OwcTooltip } from "@one/react";
import { react18WorkaroundProps } from "../../../../../utils/constants/constants";

interface BookerBadgeProps {
  initials: string;
  hasMultipleUsers: boolean;
  isPending: boolean;
  fontColor: string;
  isFirstTimeBooking?: boolean;
  style?: React.CSSProperties;
}

export const BookerBadge: React.FC<BookerBadgeProps> = ({
  initials,
  hasMultipleUsers,
  isPending,
  fontColor,
  isFirstTimeBooking = false,
  style,
}) => {
  const badgeId = React.useMemo(
    () => `booker-badge-${Math.random().toString(36).slice(2, 11)}`,
    []
  );

  return (
    <>
      <div
        id={badgeId}
        className="md-timeline-template-event-badge"
        style={{
          top: '19px',
          left: '19px',
          ...style,
          borderColor: isFirstTimeBooking
            ? '#FBFBFA'
            : (isPending ? fontColor : '#fff'),
          borderStyle: isFirstTimeBooking ? 'dashed' : 'solid',
          background: isFirstTimeBooking
            ? '#ED4A0D'
            : (isPending ? '#fff' : fontColor),
          color: isFirstTimeBooking
            ? '#FBFBFA'
            : (isPending ? fontColor : '#fff'),
        }}
      >
        <span>{initials}{hasMultipleUsers && '+'}</span>
      </div>
      {isFirstTimeBooking && (
        <OwcTooltip
          anchor={badgeId}
          placement="top"
          {...react18WorkaroundProps}
        >
          First equipment booking
        </OwcTooltip>
      )}
    </>
  );
};
